import React from 'react';
import * as Inovx from '@shared';
import EntitlementConstants from '../constants/EntitlementConstants';
import EntitlementStore from '../stores/EntitlementStore';
import EntitlementActions from '../actions/EntitlementActions';

var InovxControls = Inovx.Shared.Controls;
var CommonMessages = Inovx.Shared.Common.CommonMessages;

declare var InovxLoader: any;

interface ExternalGroupProps {
    onSelect: (externalGroup: IExternalGroup) => void;
    onCancel: () => void;
}

interface ExternalGroupState {
    validation?: IValidationDictionaryObject;
    ExternalGroups: IExternalGroup[];
    searchString: string;
    selectedExternalGroup: IExternalGroup;
    showValidationWarning: boolean;
}


function getBlankValidation(): IValidationObject {
    return { invalidInput: false, invalidValue: false, invalidInputMessage: "", invalidValueMessage: "" };
}

function getState(): ExternalGroupState {
    return {
        validation: {
            "SearchString": getBlankValidation()
        },
        ExternalGroups: [],
        searchString: "",
        selectedExternalGroup: null,
        showValidationWarning: false
    };
}

class ExternalGroup extends React.Component<ExternalGroupProps, ExternalGroupState> {

    constructor(props: ExternalGroupProps, context: any) {
        super(props, context);
        this.state = getState();
    }

    private _onRowSelect = (e: Event, externalGroup: IExternalGroup) => {
        this.setState((state) => ({
            selectedExternalGroup: externalGroup,
            showValidationWarning: (state.showValidationWarning && externalGroup) ? false : state.showValidationWarning
        }));
    }

    private _onOKClick = () => {
        if (this.state.selectedExternalGroup) {
            this.props.onSelect(this.state.selectedExternalGroup);
        }
        else {
            this.setState({
                showValidationWarning: true
            });
        }
    }

    private _onSearch = () => {
        if (this.state.searchString && !this.state.validation["SearchString"].invalidValue) {
            EntitlementActions.getSearchGroup(this.state.searchString, () => {
                var externalGroups = EntitlementStore.getExternalGroups();
                this.setState({ ExternalGroups: externalGroups });
            });
        }
    }

    private _onSearchChange = (event: any) => {
        this.setState({ searchString: event.target.value });
        this.setState((state) => {
            this._validateSearchString(state);
            return state;
        });
    }

    private _validateSearchString = (state: ExternalGroupState) => {
        if (!state.searchString) {
            state.validation["SearchString"].invalidValueMessage = CommonMessages.Validation.Required;
            state.validation["SearchString"].invalidValue = true;

            return false;
        } else {
            if (state.searchString.length < 3) {
                state.validation["SearchString"].invalidValueMessage = InovxLoader.t('Entitlement:form.searchStringTooShort');
                state.validation["SearchString"].invalidValue = true;
                return false;
            } else {
                state.validation["SearchString"].invalidValue = false;
                return true;
            }
        }
    }

    render() {
        var pagesize = 7;

        var columns = [{
            field: "DisplayName",
            headerText: InovxLoader.t('Entitlement:form.groupName')
        }];

        var dataSource = this.state.ExternalGroups;
        var defaultSort = [{
            field: "DisplayName",
            dir: "ascending"
        }];

        var searchInput = {
            className: 'form-control',
            type: 'text',
            name: 'SearchString'
        };

        return (
            <div className="panel panel-primary group-select">
                <div className="panel-heading">{InovxLoader.t('Entitlement:form.selectGroupTitle')}</div>
                <div className="panel-body">
                    <div className='group-form'>
                        <Inovx.Shared.Controls.ActionInProgressLoader actionKey={[EntitlementConstants.ENTITLEMENT_DIRECTORY_GROUP_SEARCH]} class={'temp-modal-loader'}>
                            <div className="action-in-progress-loader-sm"></div>
                        </Inovx.Shared.Controls.ActionInProgressLoader>

                        <InovxControls.FormField title={""} tooltip={""} inputName='SearchString'>
                            <InovxControls.ValidationInput {...searchInput} value={this.state.searchString} className="form-control" onChange={this._onSearchChange} validation={this.state.validation["SearchString"]} readOnly={false} autofocus={true} />
                            <button id="Group_Search_btn" onClick={this._onSearch} className='glyphicon glyphicon-search group-search-button'></button>
                        </InovxControls.FormField>
                        <Inovx.Shared.Controls.Grid dataSource={dataSource} selectRow={this._onRowSelect} reset={true} defaultSort={defaultSort}
                            columns={columns} sort={true} filter={false} scrollHeight={31 * pagesize} allowScrolling={true} autoSelectSingleRow={true} />
                        <div className="text-danger" style={{ paddingTop: "10px", display: (this.state.showValidationWarning) ? "" : "none" }}>{InovxLoader.t('Entitlement:form.selectGroupWarning')}</div>
                        <div className="btn-bar-b-sm">
                            <button type="button" className="btn btn-primary" onClick={this._onOKClick}>{InovxLoader.t('Entitlement:form.ok')}</button>
                            <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{InovxLoader.t('Entitlement:form.cancel')}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExternalGroup;
